import { COLORS } from "../../../../Diathrive/src/utils/Constants";

const styles = {
  container: {
    padding: 24,
    maxWidth: 800,
  },
  sectionHeader: {
    marginTop: 32,
    marginBottom: 8,
  },
  emptyContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: 40,
    textAlign: "center",
  },
  scheduleButton: {
    marginTop: 24,
    width: "100%",
    maxWidth: 400,
  },
  cardContainer: {
    marginTop: 16,
    padding: 16,
    borderRadius: 16,
    backgroundColor: COLORS.white,
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  },
  cardDetail: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  dateBox: {
    backgroundColor: COLORS.pink,
    borderRadius: 8,
    width: 56,
    height: 81,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 16,
    flexShrink: 0,
  },
  dateBoxPast: {
    backgroundColor: COLORS.grey2,
  },
  badge: {
    display: "inline-block",
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 3,
    paddingBottom: 3,
    borderRadius: 12,
    alignSelf: "flex-start",
  },
  cardActions: {
    display: "flex",
    flexDirection: "row",
    gap: 16,
    marginTop: 16,
    borderTop: `1px solid ${COLORS.greyLight || "#E0E4ED"}`,
    paddingTop: 16,
  },
  actionButton: {
    flex: 1,
  },
  pastCard: {
    opacity: 0.7,
  },
  typeSelectContainer: {
    padding: 24,
    maxWidth: 500,
  },
  typeSelectButtons: {
    display: "flex",
    flexDirection: "row",
    gap: 16,
    marginTop: 24,
  },
  calendlyContainer: {
    padding: 24,
  },
  backButton: {
    marginBottom: 16,
    alignSelf: "flex-start",
    maxWidth: 120,
  },
  calendlyWidget: {
    minHeight: 700,
  },
  onboardingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 24,
    maxWidth: 600,
    margin: "0 auto",
    textAlign: "center",
  },
  onboardingCard: {
    marginTop: 24,
    marginBottom: 24,
    padding: 24,
    borderRadius: 16,
    backgroundColor: COLORS.white,
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    textAlign: "center",
  },
  onboardingButton: {
    marginTop: 24,
    width: "100%",
    maxWidth: 300,
  },
  joinLink: {
    textDecoration: "underline",
    cursor: "pointer",
    marginTop: 10,
  },
  confirmCard: {
    padding: 24,
    borderRadius: 16,
    backgroundColor: "#FFFFFF",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  },
  confirmRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 12,
  },
};

export default styles;
